import script from "./SectionMediaText.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionMediaText.vue?vue&type=script&setup=true&lang=js"

import "./SectionMediaText.vue?vue&type=style&index=0&id=fadec5c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fadec5c0"]])

export default __exports__